import { useState } from "react";
import { Link } from "@/components/common/Link";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function HeaderContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [beliefsOpen, setBeliefsOpen] = useState(false);
  const [ministriesOpen, setMinistriesOpen] = useState(false);
  const [resourcesOpen, setResourcesOpen] = useState(false);
  const defaultNavItems = [{
    label: "INICIO",
    href: "/"
  }, {
    label: "SOBRE",
    href: "/about"
  }, {
    label: "CREENCIAS",
    href: "/beliefs"
  }, {
    label: "MINISTERIOS",
    href: "/Ministerios"
  }, {
    label: "MISIONES",
    href: "/missions"
  }, {
    label: "RECURSOS",
    href: "/resources"
  }, {
    label: "DONAR",
    href: "/donate"
  }, {
    label: "CONTACTO",
    href: "/contact"
  }];
  const navItems = menuItems && menuItems.length > 0 ? menuItems : defaultNavItems;
  return <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600&family=Inter:wght@300;400;500;600&display=swap');

        .utility-link:hover {
          color: #F73C4A !important;
        }

        /* Estilo para los ítems del menú principal */
        .nav-link-item {
          transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out;
          border-radius: 50px;
          padding: 8px 16px !important;
        }

        .nav-link-item:hover {
          color: #FFFFFF !important;
          background-color: #21211F !important;
        }

        .social-icon {
          transition: opacity 0.15s ease-in-out;
        }

        .social-icon:hover {
          opacity: 0.7;
        }

        .dropdown-wrapper {
          position: relative;
        }

        .dropdown-menu-custom {
          position: absolute;
          top: 100%;
          left: 0;
          background: white;
          border: 1px solid rgba(0,0,0,0.15);
          border-radius: 8px;
          padding: 8px 0;
          min-width: 160px;
          z-index: 9999;
          box-shadow: 0 4px 16px rgba(0,0,0,0.12);
        }

        .dropdown-menu-custom a {
          display: block;
          padding: 8px 16px;
          color: #21211F;
          font-size: 14px;
          text-decoration: none;
          font-family: Switzer, sans-serif;
        }

        .dropdown-menu-custom a:hover {
          background: #F5F4F2;
          color: #F73C4A;
        }
      `}</style>

      {}
      <div style={{
      backgroundColor: '#21211F',
      height: '38px',
      width: '100%',
      display: 'flex',
      alignItems: 'center'
    }}>
        <div className="page-container" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        maxWidth: '100%',
        paddingLeft: '40px',
        paddingRight: '40px'
      }}>

          {}
          <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '18px'
        }}>

            {}
            <Link to="https://www.facebook.com/asambleasdedios.cr" newTab className="social-icon" style={{
            color: '#FFFFFF',
            display: 'flex',
            alignItems: 'center'
          }} aria-label="Facebook">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
              </svg>
            </Link>

            {}
            <Link to="https://www.instagram.com/acad_costarica/" newTab className="social-icon" style={{
            color: '#FFFFFF',
            display: 'flex',
            alignItems: 'center'
          }} aria-label="Instagram">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
            </Link>

          </div>

          <div className="hidden md:flex" style={{
          alignItems: 'center',
          gap: '24px'
        }}>
            <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
              <span style={{
              color: '#FFFFFF',
              fontSize: '12px',
              fontWeight: '500',
              letterSpacing: '0.05em',
              textTransform: 'uppercase',
              fontFamily: 'Switzer, sans-serif'
            }}>
                BUSCAR
              </span>

              <div style={{
              width: '1px',
              height: '12px',
              backgroundColor: 'rgba(255,255,255,0.4)'
            }}></div>

              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/icon-search.png" alt="Search icon" style={{
              width: '15px',
              height: '15px',
              cursor: 'pointer',
              filter: 'brightness(0) invert(1)'
            }} />
            </div>

            <Link to="#" className="utility-link" style={{
            color: '#FFFFFF',
            fontSize: '13px',
            fontWeight: '500',
            letterSpacing: '0.05em',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontFamily: 'Switzer, sans-serif',
            transition: 'color 0.15s ease-in-out'
          }}>
              NOTICIAS
            </Link>

            <Link to="#" className="utility-link" style={{
            color: '#FFFFFF',
            fontSize: '13px',
            fontWeight: '500',
            letterSpacing: '0.05em',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontFamily: 'Switzer, sans-serif',
            transition: 'color 0.15s ease-in-out'
          }}>
              EVENTOS
            </Link>
          </div>

        </div>
      </div>

      {}
      <div style={{
      backgroundColor: 'rgb(255, 255, 255)',
      height: '70px',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      boxShadow: '0 1px 4px rgba(0,0,0,0.06)'
    }}>
        <div className="page-container" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        maxWidth: '100%',
        paddingLeft: '40px',
        paddingRight: '40px'
      }}>

          {}
          <Link to="/" style={{
          display: 'flex',
          alignItems: 'center',
          textDecoration: 'none',
          flexShrink: 0,
          marginRight: 'auto'
        }}>
            <img src="https://current-thrush.10web.cloud/wp-content/uploads/2026/08/footer2.png" alt="Assemblies of God" style={{
            width: '84px',
            height: 'auto',
            objectFit: 'contain'
          }} />
          </Link>

          <nav className="hidden lg:flex" style={{
          alignItems: 'center'
        }} aria-label="Main Navigation">
            <div style={{
            display: 'flex',
            alignItems: 'center',
            border: '2px solid rgba(0, 0, 0, 0.4)',
            borderRadius: '100px',
            padding: '6px 20px',
            gap: '4px'
          }}>

              {menuItems && menuItems.length > 0 ? menuItems.map(item => <Link key={item.id || item.label} to={item.href || "#"} className="nav-link-item" style={{
              color: 'rgb(33, 33, 31)',
              fontFamily: 'Switzer, sans-serif',
              fontSize: '14px',
              fontWeight: '500',
              textTransform: 'uppercase',
              textDecoration: 'none',
              letterSpacing: '0.01em',
              whiteSpace: 'nowrap'
            }}>
                    {item.label}
                  </Link>) : <>
                  <Link to="/" className="nav-link-item" style={{
                color: 'rgb(33, 33, 31)',
                fontFamily: 'Switzer, sans-serif',
                fontSize: '14px',
                fontWeight: '500',
                textTransform: 'uppercase',
                textDecoration: 'none',
                letterSpacing: '0.01em',
                whiteSpace: 'nowrap'
              }}>
                    INICIO
                  </Link>

                  <Link to="#" className="nav-link-item" style={{
                color: 'rgb(33, 33, 31)',
                fontFamily: 'Switzer, sans-serif',
                fontSize: '14px',
                fontWeight: '500',
                textTransform: 'uppercase',
                textDecoration: 'none',
                letterSpacing: '0.01em',
                whiteSpace: 'nowrap'
              }}>
                    SOBRE
                  </Link>

                  <div className="dropdown-wrapper" onMouseEnter={() => setBeliefsOpen(true)} onMouseLeave={() => setBeliefsOpen(false)}>
                    <button className="nav-link-item" style={{
                  color: 'rgb(33, 33, 31)',
                  fontFamily: 'Switzer, sans-serif',
                  fontSize: '14px',
                  fontWeight: '500',
                  textTransform: 'uppercase',
                  textDecoration: 'none',
                  letterSpacing: '0.01em',
                  whiteSpace: 'nowrap',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px'
                }}>
                      CREENCIAS

                      <svg width="8" height="5" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>

                    {beliefsOpen && <div className="dropdown-menu-custom">
                        <Link to="#">
                          Declaración de Verdades Fundamentales
                        </Link>

                        <Link to="#">
                          Nuestras Creencias Fundamentales
                        </Link>

                        <Link to="#">
                          Posiciones y Resoluciones
                        </Link>
                      </div>}
                  </div>

                  <div className="dropdown-wrapper" onMouseEnter={() => setMinistriesOpen(true)} onMouseLeave={() => setMinistriesOpen(false)}>
                    <button className="nav-link-item" style={{
                  color: 'rgb(33, 33, 31)',
                  fontFamily: 'Switzer, sans-serif',
                  fontSize: '14px',
                  fontWeight: '500',
                  textTransform: 'uppercase',
                  textDecoration: 'none',
                  letterSpacing: '0.01em',
                  whiteSpace: 'nowrap',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px'
                }}>
                      MINISTERIOS

                      <svg width="8" height="5" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>

                    {ministriesOpen && <div className="dropdown-menu-custom">
                        <Link to="#">Ministerios Infantiles</Link>
                        <Link to="#">Ministerios Juveniles</Link>
                        <Link to="#">Ministerio de Mujeres</Link>
                        <Link to="#">Ministerio de Hombres</Link>
                      </div>}
                  </div>

                  <Link to="#" className="nav-link-item" style={{
                color: 'rgb(33, 33, 31)',
                fontFamily: 'Switzer, sans-serif',
                fontSize: '14px',
                fontWeight: '500',
                textTransform: 'uppercase',
                textDecoration: 'none',
                letterSpacing: '0.01em',
                whiteSpace: 'nowrap'
              }}>
                    MISIONES
                  </Link>

                  <div className="dropdown-wrapper" onMouseEnter={() => setResourcesOpen(true)} onMouseLeave={() => setResourcesOpen(false)}>
                    <button className="nav-link-item" style={{
                  color: 'rgb(33, 33, 31)',
                  fontFamily: 'Switzer, sans-serif',
                  fontSize: '14px',
                  fontWeight: '500',
                  textTransform: 'uppercase',
                  textDecoration: 'none',
                  letterSpacing: '0.01em',
                  whiteSpace: 'nowrap',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px'
                }}>
                      RECURSOS

                      <svg width="8" height="5" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>

                    {resourcesOpen && <div className="dropdown-menu-custom">
                        <Link to="#">Publicaciones</Link>
                        <Link to="#">Medios</Link>
                        <Link to="#">Encuentre una Iglesia</Link>
                      </div>}
                  </div>

                  <Link to="#" className="nav-link-item" style={{
                color: 'rgb(33, 33, 31)',
                fontFamily: 'Switzer, sans-serif',
                fontSize: '14px',
                fontWeight: '500',
                textTransform: 'uppercase',
                textDecoration: 'none',
                letterSpacing: '0.01em',
                whiteSpace: 'nowrap'
              }}>
                    DONAR
                  </Link>

                  <Link to="#" className="nav-link-item" style={{
                color: 'rgb(33, 33, 31)',
                fontFamily: 'Switzer, sans-serif',
                fontSize: '14px',
                fontWeight: '500',
                textTransform: 'uppercase',
                textDecoration: 'none',
                letterSpacing: '0.01em',
                whiteSpace: 'nowrap'
              }}>
                    CONTACTO
                  </Link>
                </>}

            </div>
          </nav>

          {}
          <Sheet>
            <SheetTrigger asChild>
              <button className="lg:hidden" style={{
              background: 'none',
              border: '1px solid rgba(0,0,0,0.2)',
              borderRadius: '6px',
              padding: '6px 10px',
              cursor: 'pointer',
              color: '#21211F'
            }} aria-label="Open menu">
                <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1H21M1 9H21M1 17H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </button>
            </SheetTrigger>

            <SheetContent side="right" style={{
            fontFamily: 'Switzer, sans-serif',
            width: '280px'
          }}>
              <SheetHeader>
                <SheetTitle>
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/logo-color.png" alt="Assemblies of God" style={{
                  width: '70px',
                  height: 'auto'
                }} />
                </SheetTitle>
              </SheetHeader>

              <nav style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '4px',
              marginTop: '24px'
            }} aria-label="Mobile Navigation">
                {navItems.map(item => <Link key={item.label} to={item.href || "#"} style={{
                color: '#21211F',
                fontSize: '16px',
                fontWeight: '500',
                textTransform: 'uppercase',
                textDecoration: 'none',
                padding: '10px 16px',
                borderRadius: '8px',
                letterSpacing: '0.01em',
                transition: 'background 0.15s, color 0.15s'
              }} onMouseEnter={e => {
                (e.target as HTMLElement).style.color = '#F73C4A';
                (e.target as HTMLElement).style.background = '#F5F4F2';
              }} onMouseLeave={e => {
                (e.target as HTMLElement).style.color = '#21211F';
                (e.target as HTMLElement).style.background = 'transparent';
              }}>
                    {item.label}
                  </Link>)}

                <div style={{
                borderTop: '1px solid rgba(0,0,0,0.1)',
                marginTop: '16px',
                paddingTop: '16px',
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                  {[{
                  label: 'NOTICIAS',
                  href: '/news'
                }, {
                  label: 'EVENTOS',
                  href: '/events'
                }].map(item => <Link key={item.label} to={item.href} style={{
                  color: '#21211F',
                  fontSize: '14px',
                  fontWeight: '500',
                  textTransform: 'uppercase',
                  textDecoration: 'none',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  letterSpacing: '0.05em',
                  transition: 'color 0.15s'
                }}>
                      {item.label}
                    </Link>)}
                </div>
              </nav>
            </SheetContent>
          </Sheet>

        </div>
      </div>
    </>;
}
export default function Header() {
  return <header id="header" style={{
    fontFamily: 'Switzer, sans-serif',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1030,
    width: '100%'
  }}>
      <MenuProvider menu_id="16">
        <HeaderContent />
      </MenuProvider>
    </header>;
}